import React, { Component } from 'react';
import Element from './Element';
import Multiple from './Multiple';
import Header from './Header';

class ElementEditor extends Component {
  state = {
    tabShown: 0
  }

  showTab(ix) {
    this.setState({
      tabShown: ix
    });
  }

  render() {
    const tab = this.state.tabShown;
    const structure = this.props.data;
    const values = this.props.values;
    const names = this.props.names;
    const prefills = this.props.prefills;
    const defaults = this.props.defaults;

    const data = {structure, prefills, values, defaults, names, setValues: (map) => this.props.setValues(map)};

    const getElement = (path) => <Element {...data} key={path} path={path} />

    const tabs = [
      'General',
      'Visits',
      'Pregnancy',
      'Prenatal',
      'Growth Hormone Medication',
      'References'];

    return (
      <div className="editor flexy">
        <div className="flexbox-item flexbox-menu">
          <div className="tabs nav flex">
            <div className="left">
              <ul>
                {tabs.map((l, ix) =>
                  <li
                    key={ix}
                    className={'level_1' + (tab === ix ? ' active':'') + (ix === 0 ? ' first' : '') + (ix === tabs.length - 1 ? ' last' : '')}
                    onClick={() => this.showTab(ix)}>
                    <span className="label">{l}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="datacontainer flexbox-item fill-area bg">
          {tab === 0 && <div className="general">
            <div className="birth">
              <h2>Birth</h2>
              {getElement("<gavedoc><patient><birth><gestational_age><weeks>")}
              {getElement("<gavedoc><patient><birth><gestational_age><days>")}
              {getElement("<gavedoc><patient><birth><measurements><primary><height>")}
              {getElement("<gavedoc><patient><birth><measurements><primary><weight>")}
              {getElement("<gavedoc><patient><birth><measurements><primary><head_circumference>")}
            </div>
            <div className="parents">
              <h2>Parents</h2>
              {getElement("<gavedoc><patient><mother><height>")}
              {getElement("<gavedoc><patient><mother><height_sds>")}
              {getElement("<gavedoc><patient><father><height>")}
              {getElement("<gavedoc><patient><father><height_sds>")}
              <div class="element">
                <div class="formcontrol">
                  <label>&nbsp;</label>
                  <input type="text" style={{visibility: 'hidden'}}></input>
                </div>
              </div>
              {getElement("<gavedoc><patient><other><target_gp>")}
              {getElement("<gavedoc><patient><other><target_gp_sd>")}
              {getElement("<gavedoc><patient><other><target_bxp>")}
              {getElement("<gavedoc><patient><other><target_bxp_sd>")}
            </div>
            <div className="puberty">
              <h2>Puberty</h2>
              {getElement("<gavedoc><patient><menarche_date>")}
            </div>
            <div className="growthanalyser">
              <h2>GrowthAnalyser</h2>
              {getElement("<gavedoc><patient><correct_parental_height>")}
              {getElement("<gavedoc><patient><measurements_order>")}
              {getElement("<gavedoc><patient><bone_age_method>")}
              {getElement("<gavedoc><patient><testicular_volume_method>")}
              {getElement("<gavedoc><patient><dosage_regulation>")}
            </div>
          </div>}
          {tab === 1 && <div>
            <Multiple
              {...data} instanceName="visit" title="Visits"
              path="<gavedoc><patient><visit>">
              <Header>
                {getElement("<gavedoc><patient><visit><date>")}
                {getElement("<gavedoc><patient><visit><doctor>")}
              </Header>
              <div className="datacontainer">
                <div className="cols">
                  <div>
                    <h3>Bone Age</h3>
                    {getElement("<gavedoc><patient><visit><bone_age><date>")}
                    {getElement("<gavedoc><patient><visit><bone_age><twrus>")}
                    {getElement("<gavedoc><patient><visit><bone_age><twrus_sd>")}
                    {getElement("<gavedoc><patient><visit><bone_age><twrus_percentile>")}
                    {getElement("<gavedoc><patient><visit><bone_age><tw20>")}
                    {getElement("<gavedoc><patient><visit><bone_age><twcarpal>")}
                    {getElement("<gavedoc><patient><visit><bone_age><gp><years>")}
                    {getElement("<gavedoc><patient><visit><bone_age><gp><months>")}
                    {getElement("<gavedoc><patient><visit><bone_age><gp><months_sds>")}
                    {getElement("<gavedoc><patient><visit><bone_age><other>")}

                    <h3>Final height predictions</h3>
                    {getElement("<gavedoc><patient><visit><height_predictions><bp>")}
                    {getElement("<gavedoc><patient><visit><height_predictions><tw3>")}
                    {getElement("<gavedoc><patient><visit><height_predictions><bxp>")}                    
                    {getElement("<gavedoc><patient><visit><height_predictions><bxp_cm>")}

                    <h3>Puberty</h3>
                    {getElement("<gavedoc><patient><visit><puberty><mg>")}
                    {getElement("<gavedoc><patient><visit><puberty><p>")}
                    {getElement("<gavedoc><patient><visit><puberty><a>")}
                    {getElement("<gavedoc><patient><visit><puberty><testicular_volume><left>")}
                    {getElement("<gavedoc><patient><visit><puberty><testicular_volume><right>")}
                  </div>
                  <div>
                    <h3>Measurements</h3>
                    {getElement("<gavedoc><patient><visit><measurements><primary><height>")}
                    {getElement("<gavedoc><patient><visit><measurements><primary><sitting_height>")}
                    {getElement("<gavedoc><patient><visit><measurements><primary><weight>")}
                    {getElement("<gavedoc><patient><visit><measurements><primary><head_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><crown_rump_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><subischial_leg_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><arm_span>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><upper_arm_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><lower_arm_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><hand_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><tibia_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><foot_length>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><biacromial_diameter>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><biiliacal_diameter>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><mid_upper_arm_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><upper_leg_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><calf_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><hip_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><waist_circumference>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><biceps_skinfold>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><triceps_skinfold>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><subscapular_skinfold>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><suprailiacal_skinfold>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><blood_pressure_syst>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><blood_pressure_diast>")}
                    {getElement("<gavedoc><patient><visit><measurements><additional><heartrate>")}
                  </div>
                  <div>
                    <h3>Tests</h3>
                    {getElement("<gavedoc><patient><visit><tests><gh_provocation_test><max_gh_peak>")}
                    {getElement("<gavedoc><patient><visit><tests><gh_provocation_test><max_gh_peak_unit>")}
                    {getElement("<gavedoc><patient><visit><tests><bilirubin><total_serum_bilirubin>")}
                    {getElement("<gavedoc><patient><visit><tests><bia><fat_percentage>")}

                    <h3>Radiology</h3>
                    {getElement("<gavedoc><patient><visit><radiology><ultrasound><testicular_volume><left>")}
                    {getElement("<gavedoc><patient><visit><radiology><ultrasound><testicular_volume><right>")}

                    <h3>Dietary intake</h3>
                    {getElement("<gavedoc><patient><visit><dietary_intake><energy>")}
                    {getElement("<gavedoc><patient><visit><dietary_intake><protein>")}
                  </div>
                </div>
                <Multiple {...data} instanceName="fetus" title="Pregnancy: Fetuses" path="<gavedoc><patient><visit><gestation><fetus>">
                  <Header>
                    {getElement("<gavedoc><patient><visit><gestation><fetus><id>")}
                    {getElement("<gavedoc><patient><visit><gestation><fetus><gravida>")}
                  </Header>
                  <div className="datacontainer">
                    <div className="rows">
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><biparietal_diameter>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><head_circumference>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><transverse_cerebellar_diameter>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><abdominal_circumference>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><femur_length>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><crown_rump_length>")}
                      {getElement("<gavedoc><patient><visit><gestation><fetus><measurements><occipitofrontal_diameter>")}
                    </div>
                  </div>
                </Multiple>
              </div>
            </Multiple>
          </div>}
          {tab === 2 && <div>
            <Multiple {...data} instanceName="gestation" title="Pregnancy" path="<gavedoc><patient><gestation><gravida>">
              <div className="header">
                {getElement("<gavedoc><patient><gestation><gravida><id>")}
                {getElement("<gavedoc><patient><gestation><gravida><last_menstrual_period>")}
              </div>
              {getElement("<gavedoc><patient><gestation><gravida><para>")}
              {getElement("<gavedoc><patient><final_height>")}
              {getElement("<gavedoc><patient><gestation><gravida><weight>")}
              <h2>Fetus</h2>
              <Multiple {...data} instanceName="fetus" title="Fetuses" path="<gavedoc><patient><gestation><gravida><fetus>">
                {getElement("<gavedoc><patient><gestation><gravida><fetus><id>")}
                {getElement("<gavedoc><patient><gestation><gravida><fetus><gender>")}
              </Multiple>
            </Multiple>
          </div>}
          {tab === 3 && <div>
            <h2>Mother</h2>
            {getElement("<gavedoc><patient><history><gestation><mother><birthdate>")}
            {getElement("<gavedoc><patient><history><gestation><mother><para>")}
            {getElement("<gavedoc><patient><history><gestation><mother><height>")}
            {getElement("<gavedoc><patient><history><gestation><mother><weight>")}
            
            <Multiple {...data} instanceName="measurement" title="Measurements" path="<gavedoc><patient><history><gestation><measurements>">
              <div className="header">
                {getElement("<gavedoc><patient><history><gestation><measurements><date>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><doctor>")}
              </div>
              <div className="datacontainer">
                {getElement("<gavedoc><patient><history><gestation><measurements><biparietal_diameter>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><head_circumference>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><transverse_cerebellar_diameter>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><abdominal_circumference>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><femur_length>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><crown_rump_length>")}
                {getElement("<gavedoc><patient><history><gestation><measurements><occipitofrontal_diameter>")}
              </div>
            </Multiple>
          </div>}
          {tab === 4 && <div>
            <h2>Medication</h2>
            {getElement("<gavedoc><patient><medication><type>")}
            {getElement("<gavedoc><patient><medication><growth_prediction_model>")}

            <Multiple {...data} instanceName="medication" title="Doses" path="<gavedoc><patient><medication><dose>">
              {getElement("<gavedoc><patient><medication><dose><date>")}
              {getElement("<gavedoc><patient><medication><dose><name>")}
              {getElement("<gavedoc><patient><medication><dose><quantity>")}
              {getElement("<gavedoc><patient><medication><dose><unit>")}
              {getElement("<gavedoc><patient><medication><dose><nr_injections>")}
            </Multiple>
          </div>}
          {tab === 5 && <div className="references">
            <p style={{flex:'100%'}}>Override references for this patient. Please enter <strong>GA VE reference identifiers</strong> as listed <a target="_blank" href={this.props.publicPluginUrl + 'gave-reference-ids.pdf'}>here</a>.
            </p>
            <div>
              <h3>References</h3>
              {getElement("<gavedoc><patient><reference><length_gestational_age>")}
              {getElement("<gavedoc><patient><reference><weight_gestational_age>")}
              {getElement("<gavedoc><patient><reference><headcircumference_gestational_age>")}
              {getElement("<gavedoc><patient><reference><height_age>")}
              {getElement("<gavedoc><patient><reference><weight_age>")}
              {getElement("<gavedoc><patient><reference><headcircumference_age>")}
              {getElement("<gavedoc><patient><reference><sitting_height_age>")}
              {getElement("<gavedoc><patient><reference><weight_height>")}
              {getElement("<gavedoc><patient><reference><bmi_age>")}
              {getElement("<gavedoc><patient><reference><height_velocity_age>")}
              {getElement("<gavedoc><patient><reference><sitting_height_height_ratio_age>")}
            </div>
            <div>
              <h3>Prenatal</h3>
              <div>
                {getElement("<gavedoc><patient><reference><prenatal_gestational_age_crown_rump_length>")}
                {getElement("<gavedoc><patient><reference><prenatal_biparietal_diameter_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_gestational_age_biparietal_diameter>")}
                {getElement("<gavedoc><patient><reference><prenatal_head_circumference_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_transverse_cerebellar_diameter_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_abdominal_circumference_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_femur_length_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_estimated_fetal_weight_gestational_age>")}
                {getElement("<gavedoc><patient><reference><prenatal_occipitofrontal_diameter_gestational_age>")}
              </div>
            </div>
          </div>}
        </div>
      </div>
    );
  }
}

export default ElementEditor;



// WEBPACK FOOTER //
// ./src/ElementEditor.js